import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

import { useRouter } from 'vue-router'

import { Mixpanel } from '@/analytics/mixpanel'
import { ListView } from '@/models/docs.list'
import { ListItem } from '@/models/interfaces'

import ListingBlockLayout from './ListingBlockLayout.vue'
import ListCard from './ListCard.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ListingBlock',
  props: {
    view: {},
    docs: {},
    cardProps: {}
  },
  setup(__props: any) {

const props = __props

const router = useRouter()

function trackDocView(event: Event, doc: ListItem): void {
  try {
    Mixpanel.trackDocView(
      event,
      props.view.pageTitle(),
      router.currentRoute.value.fullPath,
      doc,
    )
  } catch (error) {
    // Unexpected error in the Mixpanel tracking
    console.error(error)
    return
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ListingBlockLayout, {
    class: _normalizeClass(`listing-block--${__props.view.cssClassModifier}`),
    title: __props.view.pageTitle(),
    viewAllLink: __props.view.viewAllLink,
    viewAllText: __props.view.viewAllText
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.docs, (doc) => {
        return (_openBlock(), _createBlock(ListCard, _mergeProps({
          key: doc.id,
          view: __props.view,
          doc: doc
        }, { ref_for: true }, __props.cardProps, {
          onClick: ($event: any) => (trackDocView($event, doc))
        }), null, 16, ["view", "doc", "onClick"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["class", "title", "viewAllLink", "viewAllText"]))
}
}

})